import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { IServerSideGetRowsParams } from 'ag-grid-enterprise';
import { forkJoin } from 'rxjs';
import { AuthService } from 'src/app/services/auth.service';
import { ContactService } from 'src/app/services/contact.service';
import { GridService } from 'src/app/services/grid.service';
import { UtilityService } from 'src/app/services/utility.service';

import { BaseGridComponent } from '../base-grid/base-grid.component';

@Component({
  selector: 'app-contacts-grid',
  templateUrl: '../base-grid/base-grid.component.html',
  styleUrls: [
    './contacts-grid.component.less',
    '../base-grid/base-grid.component.less'
  ],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class ContactsGridComponent extends BaseGridComponent implements OnInit {
  constructor(
    protected override GridService: GridService,
    protected override UtilityService: UtilityService,
    protected override AuthService: AuthService,
    private ContactService: ContactService
  ) {
    super(GridService, UtilityService, AuthService);
  }

  override ngOnInit(): void {
    this.gridPrimaryKeyFieldName = 'id';
    this.gridType = 'Contact';
    this.rowModelType = 'serverSide';

    this.additionalQueryData = {
      attributes: ['id']
    };

    this.ServerSideDataSource = {
      getRows: (params: IServerSideGetRowsParams) => {
        const { request } = params;

        const queryObject = this.constructGridQuery({ request });
        const countQueryObject = this.constructGridQuery(
          { request },
          { isCountQuery: true }
        );

        forkJoin([
          this.ContactService.getContacts(queryObject),
          this.ContactService.getContactCount(countQueryObject)
        ]).subscribe({
          next: ([Contacts, contactCount]) => {
            params.success({
              rowData: Contacts,
              rowCount: contactCount
            });
          },
          error: (error) => {
            console.log(error);
            params.fail();
          }
        });
      }
    };
  }
}
